import React from 'react'
import { Spin, Button } from 'antd'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import axios from 'axios'
import { injectIntl } from 'react-intl'
import endpoints from 'services/endpoints'
import moment from 'moment'
import { qualificationMap } from 'services/utils'
import { showErrorMessage } from 'services/handleErrors'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import { Amount, getAmountString } from 'components/Amount'
import RichProgressBar from 'components/RichProgressBar'
import { redirectTo } from 'services/router'
import IncomeDetails from './IncomeDetails'

import style from './style.module.scss'

class CurrentGoal extends React.Component {
  state = {
    loading: false,
  }

  componentDidMount() {
    this.getCurrentGoal()
  }

  getCurrentGoal = () => {
    this.setState({ loading: true })
    axios
      .post(endpoints.getCurrentGoal)
      .then(({ data }) => {
        const { goal, income } = data
        this.setState({ goal, income, loading: false })
      })
      .catch(err => {
        this.setState({ loading: false })
        showErrorMessage(err)
      })
  }

  renderGoalData = () => {
    const { goal, income, loading } = this.state
    const { formatMessage } = this.props.intl

    if (loading) {
      return (
        <Spin
          className={style.spinner}
          size="large"
          indicator={<LoadingOutlined />}
        />
      )
    }

    if (!goal) {
      return (
        <>
          <p className={style.noGoal}>{formatMessage({ id: 'page.dashboard.goal.not-set' })}</p>
          <Button
            icon={<PlusOutlined />}
            onClick={() => redirectTo('/create-goal')}
            type="primary"
          >
            {formatMessage({ id: 'page.dashboard.goal.set-goal' })}
          </Button>
        </>
      )
    }

    const percentageOfCompletion = goal.percentageOfCompletion
      ? parseInt(goal.percentageOfCompletion, 10)
      : 0

    switch (goal.type) {
      case 'GoalByIncome':
        return (
          <>
            <RichProgressBar
              className={style.progressBar}
              goal={<Amount value={goal.expAmount} currencyCode="rur" />}
              percent={percentageOfCompletion}
              shortPercentCaption
            />

            <div className={style.currentProgressDesc}>
              {formatMessage({ id: 'page.dashboard.goal.income.current-result' })}&nbsp;
              <nobr>
                <Amount value={income.amount} currencyCode="rur" />
              </nobr>
            </div>

            <div className={style.controls}>
              {/* <a style={{ display: 'none' }} href="#">Что мне нужно сделать?</a> */}
              <IncomeDetails />
            </div>
          </>
        )
      case 'GoalByQualification':
        return (
          <>
            <RichProgressBar
              className={style.progressBar}
              goal={
                <div>
                  {formatMessage(
                    { id: 'page.dashboard.goal.get-qualification' },
                    { expQualification: formatMessage({ id: qualificationMap[goal.expQualification] }) }
                  )}
                </div>
              }
              percent={percentageOfCompletion}
              shortPercentCaption
            />

            <div className={style.currentProgressDesc}>
              {formatMessage(
                {id: 'page.dashboard.goal.qualification.current-result.required-personal-sales' },
                {
                  required: goal.personalSalesRequired || 0,
                  currentValue: income.personalSales || 0
                }
              )}
              <br />
              {formatMessage(
                { id: 'page.dashboard.goal.qualification.current-result.required-income' },
                {
                  required: goal.incomeSecondToFifthLevelRequired && getAmountString(goal.incomeSecondToFifthLevelRequired, 'rur') || 0,
                  currentValue: income.incomeSecondToFifthLevel && getAmountString(income.incomeSecondToFifthLevel, 'rur') || 0
                }
              )}
            </div>

            <div className={style.controls}>
              {/* <a style={{ display: 'none' }} href="#">Что мне нужно сделать?</a> */}
              <IncomeDetails />
            </div>
          </>
        )
      default:
        return null
    }
  }

  render() {
    const { formatMessage } = this.props.intl

    return (
      <div className={style.currentGoal}>
        <h3>
          {formatMessage(
            { id: 'page.dashboard.goal.title' },
            { date: moment().format('MMMM YYYY') },
          )}
        </h3>
        {this.renderGoalData()}
      </div>
    )
  }
}

export default errorBoundaryEnhancer(injectIntl(CurrentGoal))
